<template>
  <div>
    <detail-mobile v-if='mobile' :data='data'></detail-mobile>
    <detail-pc v-else :data='data'></detail-pc>
  </div>
</template>

<script>
import DetailMobile from './DetailMobile'
import DetailPc from './DetailPc'
import axios from 'axios'

export default {
  name: 'hello',
  data () {
    return {
      mobile: true,
      data: null
    }
  },
  components: {
    DetailMobile, DetailPc
  },
  created () {
    window.document.title = '学员展示 | EGO'
    this.mobile = window.innerWidth <= 750
    window.onresize = () => {
      this.mobile = window.innerWidth <= 750
    }
    axios.get(`/api/member/${this.$route.params.id}`).then(res => {
      this.data = res.data
    }).catch(err => {
      alert(err)
    })
  }
}
</script>

<style scoped>

</style>
